import React, { Component } from 'react';
import logo from '../images/face_small.jpg';
import '../App.css';
import {Link} from 'react-router-dom';
import autosize from 'autosize';
/* global moment */
/* global $ */

//TODO: replace author and cat ids with pretty ones

export default class Post extends Component {
  constructor(props){
    super(props);
    
    this.state = {
      'content': '',
      'content_text': '',
      'content_loaded': false,
      'full_post': {},
      'full_post_loaded': false,
      'editing': false,
      'user_names': {},
      'report_cid': '',
      'report_c_type': '',      
    };
  }
  
  confirm_delete() {
    let firebase = this.props.app_state.firebase;
    $('#alert_working').fadeIn().delay(1500).fadeOut();
    let post_id = window.location.pathname.split('/')[2];
    let for_db = {};
    for_db[post_id+'/deleted'] = true;
    $('#post_really').modal('hide');
    firebase.database().ref('/main/posts').update(for_db)
      .then(() => {
        $('#alert_dark').text('Deleting Post').fadeIn().delay(2000).fadeOut();
      })
      .catch((error) => {
        $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
      });    
  }
  
  save_post(){    
    let firebase = this.props.app_state.firebase;
    $('#alert_working').fadeIn().delay(1500).fadeOut();
    
    this.edit_data_set = false;
    let title = $('#edit_title').val();
    let content = $('#edit_content').val();
    let cat = $('#post_choose_cat').val();
    this.setState({'editing': false});
    
    let pid = window.location.pathname.split('/')[2];
    let post_info = this.props.app_state.posts_info_dict[pid];
    let for_db = {};
    for_db['users/'+post_info.author+'/posts/'+pid+'/title'] = title;
    for_db['users/'+post_info.author+'/posts/'+pid+'/category'] = cat;
    for_db['users/'+post_info.author+'/posts/'+pid+'/updated_time'] = Date.now();
    for_db['posts/'+pid+'/title'] = title;
    for_db['posts/'+pid+'/content'] = content;
    for_db['posts/'+pid+'/category'] = cat;
    for_db['posts/'+pid+'/updated_time'] = Date.now();
    firebase.database().ref('/main').update(for_db)
      .then(() => {
        $('#alert_dark').text('Post Updated').fadeIn().delay(2000).fadeOut();
      })
      .catch((error) => {
        $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
      });    
  }
  cancel_post () {
    this.edit_data_set = false;
    $('#edit_title').val('');
    $('#edit_content').val('');
    $('#post_choose_cat').val('');
    this.setState({'editing': false});
  }
  
  save_com(parent_type, parent_com_id, com_id) {
    let firebase = this.props.app_state.firebase;
    let this_user = this.props.app_state.this_user;
    if (this_user === null) {
      return $('#alert_danger').text('Please log in first').fadeIn().delay(1500).fadeOut();
    }
    
    let comment_id = 'c_'+Date.now();
    let post_id = window.location.pathname.split('/')[2];
    let temp_comment = {
      'id': comment_id,
      'author': this_user.id,
      'author_name': this_user.name,
      'reply_to_type': parent_type,
      'num_likes': 0,
      'pub_time': Date.now(),
      'post_id': post_id,
    };
    let for_db = {};
    
    if (parent_type === 'post') {
      temp_comment['reply_to'] = post_id;
      
      let content = $('#new_com_text').val();
      if (content.replace(/\s/g, '') === ''){
        return $('#alert_danger').text('Comment is empty').fadeIn().delay(1500).fadeOut();
      }
    
      // clone because dicts are pass by reference
      for_db['/users/'+this_user.id+'/comments/'+comment_id] = $.extend(true, {}, temp_comment);
      for_db['/posts/'+post_id+'/comments/'+comment_id] = $.extend(true, {}, temp_comment);
      for_db['/posts/'+post_id+'/comments/'+comment_id]['content'] = $('#new_com_text').val();
      console.log(for_db);
      $('#new_com_text').val('');
      $('#new_com_text').animate({'height': '62px'}, 400 );
      firebase.database().ref('/main').update(for_db)
        .then(() => {
          $('#alert_dark').text('Comment Posted').fadeIn().delay(1200).fadeOut();
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
    }
    else if (parent_type === 'comment') {
      temp_comment['reply_to'] = parent_com_id;
      
      let content = $('#new_com_'+com_id).val();
      if (content.replace(/\s/g, '') === ''){
        return $('#alert_danger').text('Comment is empty').fadeIn().delay(1500).fadeOut();
      }

      
      // clone because dicts are pass by reference
      for_db['/users/'+this_user.id+'/comments/'+comment_id] = $.extend(true, {}, temp_comment);
      for_db['/posts/'+post_id+'/comments/'+parent_com_id+'/comments/'+comment_id] = 
                                                                  $.extend(true, {}, temp_comment);
      for_db['/posts/'+post_id+'/comments/'+parent_com_id+'/comments/'+comment_id]['content'] = 
                                                                                             content;
      console.log(for_db);
      $('#new_com_cont_'+com_id).fadeOut();
      $('#new_com_'+com_id).val('').css({'height': '62px'});
      firebase.database().ref('/main').update(for_db)
        .then(() => {
          $('#alert_dark').text('Comment Posted').fadeIn().delay(1200).fadeOut();
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
    }
  }
  
  bookmark (saved) {
    let firebase = this.props.app_state.firebase;
    
    if (!this.props.app_state.this_user_loaded)
      return;
    let this_user = this.props.app_state.this_user;
    let for_state = {};
    let pid = window.location.pathname.split('/')[2];
    
    if (!saved) {
      // save this post in bookmarks
      for_state[this_user.id+'/bookmarks/'+pid+'/post_id'] = pid;
      for_state[this_user.id+'/bookmarks/'+pid+'/time'] = Date.now();
      for_state[this_user.id+'/bookmarks/'+pid+'/type'] = 'post';
      firebase.database().ref('/main/users').update(for_state)
        .then(() => {
          $('#alert_dark').text('Post bookmarked').fadeIn().delay(1500).fadeOut();          
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
    }
    else {
      // remove from user bookmarks
      for_state[this_user.id+'/bookmarks/'+pid] = null;
      firebase.database().ref('/main/users').update(for_state)
        .then(() => {
          $('#alert_dark').text('Bookmark removed').fadeIn().delay(1500).fadeOut();          
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
    }
    
  }
  
  // check local storage available
  ls_test(){
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }
  }

  comment_liked(cid) {
    if (this.state.full_post_loaded 
          && typeof (this.state.full_post||{}).comments !== 'undefined'
          && this.props.app_state.this_user_loaded) {
      let this_comment = this.state.full_post['comments'][cid];
      let liked_list = [];
      if (this.props.app_state.this_user !== null) {
        let liked_comments = this.props.app_state.this_user.liked_comments||{};
        for(let lid in liked_comments) {
          liked_list.push(liked_comments[lid].comment_id);
        }
      }
      else {
        if (!this.ls_test()) {
          console.log('local storage is missing');
          return;
        }
        
        let liked_comments = JSON.parse(localStorage.getItem('liked_comments')) || {};
        for(let lid in liked_comments) {
          liked_list.push(liked_comments[lid].comment_id);
        }
      //console.log('checking', liked_comments)
      }
      if (liked_list.includes(cid)) {
        // already liked this comment
        return true;
      }            
    }
    return false;
  }
  like_comment(cid, num_comments, reply_to_type, reply_to) {
    let firebase = this.props.app_state.firebase;
    
    if (this.state.full_post_loaded 
          && typeof (this.state.full_post||{}).comments !== 'undefined'
          && this.props.app_state.this_user_loaded) {      
          
      let this_comment;
      if (reply_to_type === 'comment')
        this_comment = this.state.full_post['comments'][reply_to]['comments'][cid];
      else
        this_comment = this.state.full_post['comments'][cid];
      
      if (this_comment.author === (this.props.app_state.this_user||{}).id) {
        console.log('you cannot like your own comment')
        return;
      }
        
      
      if (this.comment_liked.call(this, cid)) {
        // already liked this comment
        console.log('you already liked this comment')
        return;
      }      
        
      let path;
      let for_db = {};
      if (this_comment.reply_to_type === 'comment') {
        path = '/posts/'+this_comment.post_id+'/comments/'+this_comment.reply_to
                      +'/comments/'+this_comment.id+'/num_likes';
      }
      else {
        path = '/posts/'+this_comment.post_id
                      +'/comments/'+this_comment.id+'/num_likes';
        
      }
      for_db[path] = this_comment.num_likes + 1;
      
      if (this.props.app_state.this_user !== null) {
        let this_user = this.props.app_state.this_user; 
        for_db['/users/'+this_user.id+'/liked_comments/'+cid+'/comment_id'] = cid;
      }
      else {
        // no user. use local storage
        let for_local = JSON.parse(localStorage.getItem('liked_comments')) || {};
        for_local[cid] = {
          'comment_id': cid
        };
        localStorage.setItem('liked_comments', JSON.stringify(for_local));
      }
      firebase.database().ref('/main').update(for_db)
        .catch((error) => {
          console.log(error);
        });
    }
    else {
      console.log('waiting for user and post');
    }
  }
  
  confirm_report_post() {
    let firebase = this.props.app_state.firebase;
    
    if ($('#report_post_message').val() === '') {
      $('#alert_danger').text('Please add a message').fadeIn().delay(2000).fadeOut();
      return;
    }
    
    let for_db = {};
    for_db['reporter'] = (this.props.app_state.this_user||{}).id;
    for_db['reporter_name'] = (this.props.app_state.this_user||{}).name;
    for_db['type'] = 'post';
    for_db['reported_id'] = window.location.pathname.split('/')[2];
    for_db['reported_time'] = Date.now();
    for_db['comment'] = $('#report_post_message').val();
    let rep_id = 'r_'+Date.now()+'_'+Math.floor(Math.random() * 1000);
    for_db['id'] = rep_id;
    firebase.database().ref('/main/reports/'+rep_id).update(for_db)
      .then(() => {
        $('#alert_dark').text('Report Submitted').fadeIn().delay(1500).fadeOut();
        $('#report_post').modal('hide');
        $('#report_post_message').val('');
      })
      .catch((error) => {
        $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();        
      });    
  }
  
  confirm_report_comment() {
    let firebase = this.props.app_state.firebase;
    
    if ($('#report_com_message').val() === '') {
      $('#alert_danger').text('Please add a message').fadeIn().delay(2000).fadeOut();
      return;
    }
    
    let for_db = {};
    for_db['reporter'] = (this.props.app_state.this_user||{}).id;
    for_db['reporter_name'] = (this.props.app_state.this_user||{}).name;
    for_db['type'] = this.state.report_c_type;
    for_db['reported_id'] = this.state.report_cid;
    for_db['reported_time'] = Date.now();
    for_db['comment'] = $('#report_com_message').val();
    let rep_id = 'r_'+Date.now()+'_'+Math.floor(Math.random() * 1000);
    for_db['id'] = rep_id;
    firebase.database().ref('/main/reports/'+rep_id).update(for_db)
      .then(() => {
        $('#alert_dark').text('Report Submitted').fadeIn().delay(1500).fadeOut();
        $('#report_comment').modal('hide');
        $('#report_com_message').val('');
      })
      .catch((error) => {
        $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();        
      });    
  }
  
  // react life cycle
  edit_data_set = false;
  is_my_post = false;
  componentDidUpdate(prev_props, prev_state) {
    if (this.state.editing && this.props.app_state.posts_info_loaded
                            && (this.is_my_post
                                || (this.props.app_state.this_user||{}).is_admin)
                            && !this.edit_data_set
                            && this.state.content_loaded) {
      // set defaults for post edit elements
      let pid = window.location.pathname.split('/')[2];
      $('#edit_title').val(this.props.app_state.posts_info_dict[pid].title);
      $('#edit_content').val(this.state.content_text);
      $('#post_choose_cat').val(this.props.app_state.posts_info_dict[pid].category);
      
      console.log(this.state.content_text)
    }
    autosize($('textarea'));
  }
  componentDidMount() {
    let firebase = this.props.app_state.firebase;
    window.scrollTo(0, 0);
    
    let post_id = window.location.pathname.split('/')[2];
    let db = firebase.database().ref('main/posts/'+post_id);
    db.on('value', (snap) => {
      let raw_text = (snap.val()||{}).content||'';
      let content = [];
      
      raw_text.split('\n').forEach((para) => {
        if (para === '')
          content.push(<p className="post_para_blank"></p>);
        else
          content.push(<p className="post_para">{para}</p>);
      });
      
      this.setState({'content': content, 
                            'content_loaded': true, 
                            'content_text': raw_text,
                            'full_post': snap.val(),
                            'full_post_loaded': true});
    });    
    
    if (window.location.hash.substring(1) === 'edit') {
      this.setState({'editing': true});
      window.history.replaceState("", document.title, window.location.pathname
                                                      + window.location.search);
    }
    
    autosize($('textarea'));
  }
  
  
  
  render() {
    let post_id = window.location.pathname.split('/')[2];
    let post_info = {};
    let num_comments_txt = '';
    if (this.props.app_state.posts_info_loaded) {
      post_info = this.props.app_state.posts_info_dict[post_id]||{};
      
      if (Object.keys(post_info).length === 0)
        return <h3>Post {post_id} does not exist</h3>;
      
      num_comments_txt = (post_info.num_comments === 0)?'No':post_info.num_comments;
      num_comments_txt += ' Comment';
      num_comments_txt += (post_info.num_comments === 1)?'':'s';
      num_comments_txt += ' on "' + post_info.title + '"';
    }
    
    
    let render_content = this.state.content;
    if (this.state.content === '')
      if (this.state.content_loaded)
        render_content = <h3 style={{"textAlign": "center"}}>Nothing Here</h3>;
      else
        render_content = <h3 className="text-muted center">Loading...</h3>;
    
    this.is_my_post = (this.props.app_state.this_user !== null
                        && post_info.author === this.props.app_state.this_user.id);
    let edit_btns = null;
    
    if (this.is_my_post 
          || (this.props.app_state.this_user||{}).is_admin) {
      if (this.state.editing) {
        edit_btns = <div id="edit_btn_cont">
          <button className="btn btn-dark"
                    onClick={this.save_post.bind(this)}>Save</button>
          <button className="btn btn-outline-danger"
                    onClick={this.cancel_post.bind(this)}>Cancel</button>
        </div>;        
      }
      else {
        edit_btns = <div id="edit_btn_cont">
          <button className="btn btn-dark"
                    onClick={e => this.setState({'editing': true})}>Edit Post</button>
          <button className="btn btn-outline-danger"
                    onClick={e => $('#post_really').modal('show')}>Delete Post</button>
        </div>;
      }
    }
    
    if ((this.is_my_post 
            || (this.props.app_state.this_user||{}).is_admin)
            && this.state.editing) {
      let cat_options = [<option selected value=''>Choose Category...</option>];
      for(let cid in cat_names) {
        cat_options.push(<option value={cid}>
          {cat_names[cid]}
        </option>);
      }
      render_content = <div>
        <h4>Title</h4>
        <input id="edit_title" className="form-control"/>
        <h4 style={{"marginTop": "20px"}}>Content</h4>
        <textarea id="edit_content" className="form-control"></textarea>
        <select className="custom-select" id="post_choose_cat">          
          {cat_options}
        </select>        
      </div>;
    }
    
    let author_text = post_info.author_name || post_info.author;
    
    // comments
    let comments_xml_list = [];
    if (this.state.full_post_loaded 
          && typeof (this.state.full_post||{}).comments !== 'undefined') {
      let comments = this.state.full_post['comments'];
      let com_author_name;
      let comments2;
      let comment_list = [];
      for (let cid in comments) { 
        comment_list.push(comments[cid]);
      }
      comment_list.sort((a, b) => {
        return a.pub_time - b.pub_time;
      });
      
      comment_list.forEach((this_comment) => {
        let cid = this_comment.id;
        com_author_name = this_comment.author_name || this_comment.author;
        let report_btn = null;
        if (this.props.app_state.this_user)
          report_btn = <t className="com_report"
                  onClick={(e) => {
                    $('#report_comment').modal('show');
                    this.setState({'report_c_type': 'comment',
                                    'report_cid': cid,
                                    'report_c_content': this_comment.content});
                  }}>
                <i className="material-icons">priority_high</i>
                Report
              </t>;
          
        comments_xml_list.push(<div className="row">
          <div className="com_img_cont">
            <Link to={"/user/"+this_comment.author}>
              <img src={logo} className="com_img" alt="logo" />
            </Link>
          </div>
          <div className="com_content_cont">
            <Link to={"/user/"+this_comment.author} className="com_author">{com_author_name}</Link>
            <p className="com_content">{this_comment.content}</p>
            
            <div className={("comment_group "+(this.comment_liked.call(this, cid)?'liked':''))}
                  onClick={this.like_comment.bind(this, cid, this_comment.num_likes, 'post', post_id)}>
              <i className="material-icons">
                {(this.comment_liked.call(this, cid)?'favorite':'favorite_border')}
              </i>
              <t>{this_comment.num_likes||0}</t>
            </div>
            
            <t className="com_time_reply">
              <t id="reply_link"
                  onClick={e => $('#new_com_cont_'+cid).fadeIn()}>
                <i className="material-icons">reply</i>Reply
              </t>
              
              <i className="material-icons">access_time</i>
              {moment(this_comment.pub_time).fromNow()}
              
              {report_btn}
            </t>
            <div id={"new_com_cont_"+cid} className="nested_com_cont">
              <textarea placeholder="Reply..."
                className="form-control"
                id={"new_com_"+cid}/>
              <button className="btn btn-dark"
                      onClick={this.save_com.bind(this, 'comment', cid, cid)}>Post</button>
              <button className="btn btn-outline-danger"
                      onClick={e => {$('#new_com_cont_'+cid).fadeOut();
                                      $('#new_com_'+cid).val('')
                                            .css({'height': '62px'})}}>
                Cancel
              </button>
            </div>
            <hr/>
          </div>
        </div>);
        
        if (typeof this_comment['comments'] !== 'undefined') {
          comments2 = this_comment['comments'];
          
          let comment_list2 = [];
          for (let cid2 in comments2) { 
            comment_list2.push(comments2[cid2]);
          }
          comment_list2.sort((a, b) => {
            return a.pub_time - b.pub_time;
          });
          
          comment_list2.forEach((this_comment2) => {
            let cid2 = this_comment2.id;
            com_author_name = this_comment2.author_name || this_comment2.author;
            
            let report_btn2 = null;
            if (this.props.app_state.this_user)
              report_btn2 = <t className="com_report"
                    onClick={(e) => {
                      $('#report_comment').modal('show');
                      this.setState({'report_c_type': 'nested_comment',
                                      'report_cid': cid2,
                                      'report_c_content': this_comment2.content});
                    }}>
                    <i className="material-icons">priority_high</i>
                    Report
                  </t>;
              
            comments_xml_list.push(<div className="row nested_comment">
              <div className="com_img_cont">
                <Link to={"/user/"+this_comment2.author}>
                  <img src={logo} className="com_img" alt="logo" />
                </Link>
              </div>
              <div className="com_content_cont">
                <Link to={"/user/"+this_comment2.author} className="com_author">{com_author_name}</Link>
                <p className="com_content">{this_comment2.content}</p>
                
                <div className={("comment_group "+(this.comment_liked.call(this, cid2)?'liked':''))}
                      onClick={this.like_comment.bind(this, cid2, this_comment2.num_likes, 'comment', cid)}>
                  <i className="material-icons">
                    {(this.comment_liked.call(this, cid2)?'favorite':'favorite_border')}
                  </i>
                  <t>{this_comment2.num_likes||0}</t>
                </div>
                
                <t className="com_time_reply">                  
                  <t id="reply_link"
                      onClick={e => $('#new_com_cont_'+cid2).fadeIn()}>
                    <i className="material-icons">reply</i>Reply
                  </t>
                  
                  <i className="material-icons">access_time</i>
                  {moment(this_comment2.pub_time).fromNow()}
                  
                  {report_btn2}
                </t>
                <div id={"new_com_cont_"+cid2} className="nested_com_cont">
                  <textarea placeholder="Reply..."
                    className="form-control"
                    id={"new_com_"+cid2}/>
                  <button className="btn btn-dark"
                          onClick={this.save_com.bind(this, 'comment', cid, cid2)}>Post</button>
                  <button className="btn btn-outline-danger"
                          onClick={e => {$('#new_com_cont_'+cid2).fadeOut();
                                         $('#new_com_'+cid2).val('')
                                            .css({'height': '62px'});}}>
                    Cancel
                  </button>
                </div>
                <hr/>
              </div>
            </div>);
          });
        }        
      });
    }
    
    let comments_xml = <div>
      {comments_xml_list}
    </div>;
    
    
    // make comments  
    let make_comment = <div className="new_com_div">
      <t onClick={e=>$('#login_modal').modal('show')}
          className="login_to_comment">
        Login to Comment
      </t>
    </div>;
    
    if(this.props.app_state.this_user !== null) {
      make_comment = <div className="new_com_div">
        <textarea placeholder="Join discussion..."
                  className="form-control"
                  id="new_com_text"/>
        <div id="new_com_btns">  
          <button className="btn btn-dark"
                  onClick={this.save_com.bind(this, 'post')}>Post</button>
          <button className="btn btn-outline-danger"
                  onClick={e => {$('#new_com_text').val('');
                                 $('#new_com_text').animate({'height': '62px'}, 400 )}}>
            Cancel
          </button>
        </div>
      </div>;
    }
    
    let bookmark_btn = null;
    if (this.props.app_state.this_user) {
      let user_bookmarks = [];
      let mark_dict = this.props.app_state.this_user.bookmarks||{};
      for (let mark_key in mark_dict) {
        user_bookmarks.push(mark_dict[mark_key].post_id);
      }
      if (!user_bookmarks.includes(post_id)) {
        bookmark_btn = <button id="bookmark_btn"
                                onClick={this.bookmark.bind(this, false)} 
                                className="btn btn-outline-dark">
            Bookmark
            <i className="material-icons">bookmark_border</i>
          </button>
      }
      else {
        bookmark_btn = <button id="bookmark_btn"
                                onClick={this.bookmark.bind(this, true)} 
                                className="btn btn-dark">
            Saved
            <i className="material-icons">bookmark</i>
          </button>
      }
    }
    
    // <h6 id="post_num_comments">{num_comments_txt}</h6>
    // <hr/>
    let report_btn = null;
    if (this.props.app_state.this_user)
      report_btn = <p className="report_post_btn"
          onClick={e => $('#report_post').modal('show')}>
        Report this post
      </p>;
    
    
    return (
      <div id="post_div">
        <h1 className="post_title" style={{"marginBottom": "20px"}}>
          {post_info.title}
        </h1>
        <hr/>
        <div id="post_info_bar" >
          <i className="material-icons">date_range</i>
          {(post_info.pub_time)?moment(post_info.pub_time).format('MMMM Do, YYYY'):''} 
          &nbsp; / &nbsp; 
          <Link to={"/user/"+post_info.author}>        
            <i className="material-icons" style={{"marginRight": "2px"}}>person</i>
            {author_text}
          </Link>
          &nbsp; / &nbsp; 
          <Link to={"/category/"+((post_info.category||'miscellaneous').toLowerCase())}>            
            <i className="material-icons">folder_open</i>
            {cat_names[(post_info.category||'miscellaneous').toLowerCase()]}
          </Link>
        </div>
        <hr/>
        <div id="post_content">
          {render_content}
        </div>
        {edit_btns}
        {bookmark_btn}
        {report_btn}
        <h3 id="post_leave_reply">Leave a Reply</h3>
        <hr/>
        <br/>
        {make_comment}
        {comments_xml}
        
        
        <div id="post_really" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Are you sure?</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal_body">
              You are about to delete the following post:<br/>
              <t style={{"fontWeight":"bold"}}>{post_info.title}</t><br/>
              Please confirm
            </div>
            
            <div style={{'margin-top': '20px'}} className="modal-footer">
              <button onClick={this.confirm_delete.bind(this)} type="button" className="btn btn-dark">Confirm</button>
              <button type="button" className="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
        </div>
        
        <div id="report_post" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">What's wrong?</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal_body">
              <strong>You are about to report this post</strong>. <br/>
              <strong>Say why</strong>:
              <textarea id="report_post_message" 
                          className="form-control"
                          placeholder="Message...">
              </textarea>
            </div>
            
            <div style={{'margin-top': '20px'}} className="modal-footer">
              <button onClick={this.confirm_report_post.bind(this)} type="button" className="btn btn-dark">Confirm</button>
              <button type="button" className="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
        </div>
        
        <div id="report_comment" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">What's wrong?</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal_body">
              <strong>You are about to report this comment</strong>:<br/>
              <em>"{(this.state.report_c_content||'').substring(0, 100)+'...'}"</em><br/>
              <strong>Say why</strong>:
              <textarea id="report_com_message" 
                          className="form-control"
                          placeholder="Message...">
              </textarea>
            </div>
            
            <div style={{'margin-top': '20px'}} className="modal-footer">
              <button onClick={this.confirm_report_comment.bind(this)} type="button" className="btn btn-dark">Confirm</button>
              <button type="button" className="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

const cat_names = {
  'relationships': 'Relationships',
  'mentalhealth': 'Mental Health',
  'sexualorientation': 'Sexual Orientation',
  'loss': 'Loss',
  'race': 'Race',
  'suicide': 'Suicide',
  'abuse': 'Abuse',
  'addiction': 'Addiction',
  'eatingdisorders': 'Eating Disorders',
  'miscellaneous': 'Miscellaneous',
  'religion': 'Religion',
}



// WEBPACK FOOTER //
// ./src/components/Post.js